module.exports = __webpack_public_path__ + "static/media/scaled-small.e1d4b8be.webp";